'use client';

import type { ReactNode } from 'react';
import { NodeToolbar, Position, useStore } from '@xyflow/react';
import { GRAPH_NODE_CIRCLE_SIZE } from './constants';

const TOOLBAR_GAP_PX = 16;

type ExternalNetworkGraphNodeToolbarProps = {
  nodeId: string;
  children: ReactNode;
};

export function ExternalNetworkGraphNodeToolbar({
  nodeId,
  children,
}: ExternalNetworkGraphNodeToolbarProps) {
  const circleInsetPx = useStore((state) => {
    const nodeWidth =
      state.nodeLookup.get(nodeId)?.measured.width ?? GRAPH_NODE_CIRCLE_SIZE;

    return (
      (Math.max(nodeWidth - GRAPH_NODE_CIRCLE_SIZE, 0) / 2) * state.transform[2]
    );
  });

  return (
    <NodeToolbar
      isVisible
      position={Position.Right}
      align="start"
      offset={TOOLBAR_GAP_PX - circleInsetPx}
    >
      {children}
    </NodeToolbar>
  );
}
